export const STRUCTURE = 'structure'
export const OWN = 'own'
export const DIRECT = 'direct'
export const SPECIALIST = 'specialist'